'use client';

import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'next/navigation';

import { useOAuth } from '@personly/libs-hooks';

import useClients from '@/hooks/clients';

const OAuthValues = () => {
  const searchParams = useSearchParams();

  const { client, getClient } = useClients();
  const { responseType, state, redirectUri, scope } = useOAuth(
    searchParams,
    client
  );

  const clientId = useMemo(() => {
    const id = searchParams.get('client_id');

    return id || process.env.NEXT_PUBLIC_CLIENT_PERSONLY_MY!;
  }, [searchParams]);

  useEffect(() => {
    if (!clientId) return;

    getClient(clientId);
  }, [getClient, clientId]);

  return (
    <>
      <input type="hidden" name="client_id" value={clientId}></input>
      <input type="hidden" name="redirect_uri" value={redirectUri}></input>
      <input type="hidden" name="response_type" value={responseType}></input>
      <input type="hidden" name="scope" value={scope}></input>
      <input type="hidden" name="state" value={state}></input>
    </>
  );
};

export default OAuthValues;
